/**
 * Footer — shown on every page.
 *
 * showDonate: bool — show the donation line (home + results pages only)
 */
export default function Footer({ showDonate = false }) {
  return (
    <footer
      style={{
        position: 'relative', zIndex: 1,
        borderTop: '1px solid var(--border)',
        marginTop: 64,
        padding: '28px 24px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        alignItems: 'center',
      }}
    >
      {showDonate && (
        <p style={{ fontSize: 13, color: 'var(--muted)' }}>
          ☕ Buy me a tea, Earl Grey, hot.{' '}
          <a
            href="https://venmo.com/theplanetmike"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--accent2)', textDecoration: 'underline' }}
            aria-label="Donate via Venmo to @theplanetmike (opens in new tab)"
          >
            Venmo @theplanetmike
          </a>
          {' · '}
          <a
            href="https://cash.app/$theplanetmike"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--accent2)', textDecoration: 'underline' }}
            aria-label="Donate via Cash App to $theplanetmike (opens in new tab)"
          >
            Cash App $theplanetmike
          </a>
        </p>
      )}

      <p style={{ fontSize: 11, color: 'var(--muted)' }}>
        Galactic Meeting strives to meet{' '}
        <a
          href="https://www.w3.org/TR/WCAG22/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'var(--muted)', textDecoration: 'underline' }}
          aria-label="WCAG 2.2 accessibility guidelines (opens in new tab)"
        >
          WCAG 2.2 Level AA
        </a>
        {' '}accessibility standards. If you encounter a barrier, please{' '}
        <a
          href="mailto:theplanetmike@gmail.com"
          style={{ color: 'var(--muted)', textDecoration: 'underline' }}
        >
          let us know
        </a>
        .
      </p>
    </footer>
  );
}
